export const isPreviewPage = (pathname: string): boolean => {
  return pathname.includes('/preview');
};
